<div class="container-fluid">
  <!-- LIST VIEW -->

  <div *ngIf="!showForm">
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h5>Invite Society Member</h5>

        <div>
          <button class="btn btn-primary me-2" (click)="openAddInvite()">
            + Add Invite
          </button>

          <img
            src="./assets/excelIcons/excel_download.svg"
            class="downloadExcelIcon"
            (click)="handleDownloadInviteExcel()"
          />

          <label>
            <img
              src="./assets/excelIcons/excel_upload.svg"
              class="uploadExcelIcon"
            />

            <input
              hidden
              type="file"
              accept=".xlsx,.xls"
              (change)="handleInviteExcelUpload($event)"
            />
          </label>
        </div>
      </div>

      <div class="card-body">
        <ul class="nav custom-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="selectedStatus === 'Initiated'"
              (click)="changeStatus('Initiated')"
            >
              Initiated
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="selectedStatus === 'Processing'"
              (click)="changeStatus('Processing')"
            >
              Processing
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              [class.active]="selectedStatus === 'Completed'"
              (click)="changeStatus('Completed')"
            >
              Completed
            </a>
          </li>
        </ul>

        <table class="table mt-3">
          <thead>
            <tr>
              <th>Sr No</th>

              <th>Flat Owner Name</th>

              <th>Flat Member Name</th>

              <th>Mobile No</th>

              <th>Status</th>

              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="filteredInviteList.length == 0">
              <td colspan="6" class="text-center">No Invite Found</td>
            </tr>

            <tr *ngFor="let item of paginatedInviteList; let i = index">
              <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>

              <td>{{ item.primaryName || "-" }}</td>

              <td>{{ item.secondaryName || "-" }}</td>

              <td>{{ item.mobileNo || "-" }}</td>

              <td>
                <span
                  class="fw-semibold"
                  [style.color]="getStatusTextColor(item.inviteStatus)"
                >
                  {{ item.inviteStatus || "-" }}
                </span>
              </td>

              <td>
                <!-- THREE DOT ACTION MENU -->
                <div
                  class="position-relative d-inline-block invite-action-wrapper"
                >
                  <button
                    type="button"
                    class="btn btn-sm border-0 bg-transparent p-1"
                    title="Actions"
                    (click)="toggleActionMenu(i, $event)"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>

                  <div
                    *ngIf="activeMenuIndex === i"
                    class="position-absolute bg-white border rounded shadow-sm py-1"
                    style="right: 0; top: 100%; min-width: 130px; z-index: 1055"
                    (click)="$event.stopPropagation()"
                  >
                    <button
                      type="button"
                      class="dropdown-item d-flex align-items-center"
                      (click)="editInvite(item, $event)"
                    >
                      <i class="bi bi-pencil-square me-2 text-primary"></i>
                      Edit
                    </button>

                    <button
                      type="button"
                      class="dropdown-item d-flex align-items-center"
                      (click)="deleteInvite(item, $event)"
                    >
                      <i class="bi bi-trash me-2 text-danger"></i>
                      Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATION -->
        <div
          class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
          *ngIf="filteredInviteList.length > 0"
        >
          <div class="small text-muted">
            Page {{ currentPage }} of {{ totalPages }}
            |
            Showing {{ showingFrom }} to {{ showingTo }}
            |
            Total Records : {{ filteredInviteList.length }}
          </div>

          <div class="d-flex align-items-center gap-2">
            <button
              type="button"
              class="btn btn-sm border-0 bg-transparent p-1"
              [disabled]="currentPage === 1"
              [style.opacity]="currentPage === 1 ? '0.35' : '1'"
              (click)="changePage(currentPage - 1)"
              aria-label="Previous page"
            >
              &lt;
            </button>

            <button
              *ngFor="let page of pageNumbers"
              type="button"
              class="btn btn-sm border-0"
              [style.min-width.px]="30"
              [style.height.px]="30"
              [style.border-radius.px]="7"
              [style.background]="
                page === currentPage ? '#4a0b5f' : '#f2e7f6'
              "
              [style.color]="
                page === currentPage ? '#ffffff' : '#6f2b84'
              "
              (click)="changePage(page)"
            >
              {{ page }}
            </button>

            <button
              type="button"
              class="btn btn-sm border-0 bg-transparent p-1"
              [disabled]="currentPage === totalPages"
              [style.opacity]="currentPage === totalPages ? '0.35' : '1'"
              (click)="changePage(currentPage + 1)"
              aria-label="Next page"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ADD / EDIT INVITE MODAL -->
  <div
    class="modal fade"
    [class.show]="showForm"
    [class.d-block]="showForm"
    tabindex="-1"
    *ngIf="showForm"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ editingInvite ? "Edit Society Invite" : "Create Society Invite" }}
          </h5>

          <button
            type="button"
            class="btn-close"
            (click)="closeForm()"
          ></button>
        </div>

        <div class="modal-body">
          <form [formGroup]="inviteForm" (ngSubmit)="submit()">
            <div class="row">
              <!-- Flat Owner Name -->
              <div class="col-md-6 mb-3">
                <label> Flat Owner Name </label>

                <input
                  class="form-control"
                  formControlName="primaryName"
                />
              </div>

              <!-- Flat Member Name -->
              <div class="col-md-6 mb-3">
                <label> Flat Member Name </label>

                <input
                  class="form-control"
                  formControlName="secondaryName"
                />
              </div>

              <!-- Mobile No (mandatory) -->
              <div class="col-md-6 mb-3">
                <label>
                  Mobile No
                  <span class="text-danger">*</span>
                </label>

                <input
                  #mobileNoInput
                  maxlength="10"
                  inputmode="numeric"
                  class="form-control"
                  [class.is-invalid]="
                    inviteForm.get('mobileNo')?.invalid &&
                    inviteForm.get('mobileNo')?.touched
                  "
                  formControlName="mobileNo"
                />

                <div
                  class="invalid-feedback d-block"
                  *ngIf="
                    inviteForm.get('mobileNo')?.hasError('required') &&
                    inviteForm.get('mobileNo')?.touched
                  "
                >
                  Mobile No is required.
                </div>

                <div
                  class="invalid-feedback d-block"
                  *ngIf="
                    !inviteForm.get('mobileNo')?.hasError('required') &&
                    inviteForm.get('mobileNo')?.hasError('pattern') &&
                    inviteForm.get('mobileNo')?.touched
                  "
                >
                  Please enter valid 10 digit Mobile No.
                </div>
              </div>

              <!-- Building dropdown -->
              <div class="col-md-3 mb-3">
                <label> Building </label>

                <select class="form-control" formControlName="identifier1">
                  <option value="">-- Select Building --</option>

                  <option
                    *ngFor="let b of buildingList"
                    [value]="b.buildingId || b.BuildingId"
                  >
                    {{ b.buildingName || b.BuildingName || b.name }}
                  </option>
                </select>
              </div>

              <!-- Flat dropdown -->
              <div class="col-md-3 mb-3">
                <label> Flat </label>

                <select class="form-control" formControlName="identifier2">
                  <option value="">-- Select Flat --</option>

                  <option
                    *ngFor="let f of flatList"
                    [value]="f.flatId || f.FlatId"
                  >
                    {{ f.flatNo || f.FlatNo || f.flatNumber || f.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="text-end">
              <button
                type="button"
                class="btn btn-secondary me-2"
                (click)="closeForm()"
              >
                Cancel
              </button>

              <button class="btn btn-primary" type="submit">
                {{ editingInvite ? "Update Invite" : "Send Invite" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show" *ngIf="showForm"></div>
</div>